export function renderStartupError(message: string, error: unknown): void {
  console.error(message, error);

  const root = document.querySelector('club-ia-standalone-root');
  if (!root) return;

  const main = document.createElement('main');
  main.setAttribute('role', 'alert');
  main.style.cssText = 'max-width:42rem;margin:4rem auto;padding:1.5rem;font-family:system-ui,sans-serif';

  const eyebrow = document.createElement('p');
  eyebrow.textContent = 'Club IA';
  eyebrow.style.cssText = 'color:#4338ca;font-weight:800;text-transform:uppercase';

  const title = document.createElement('h1');
  title.textContent = 'Não foi possível iniciar o aplicativo';

  const description = document.createElement('p');
  description.textContent = 'Atualize a página. Se o problema continuar, use os outros produtos normalmente e tente novamente mais tarde.';

  main.append(eyebrow, title, description);
  root.replaceChildren(main);
}
